// extracted by mini-css-extract-plugin
export default {"hasError":"VFModalTestDenominationsSubmitBatchTable_hasError__Vand6"};